import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

    }

    init() {
        
        this.$days = this.$('day');

        this.swiperDays = new Swiper(this.$('days')[0], {
            loop: false,
            slidesPerView: 'auto',
            speed: 500,
            slidesPerColumn: 1,
            freeMode: {
                enable: true,
                sticky: false
            }
        });

        this.swiper = new Swiper(this.$('slider')[0], {
            loop: false,
            slidesPerView: "auto",
            loopedSlides: 5,
            speed: 800,
            allowTouchMove: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            thumbs: {
                swiper: this.swiperDays
            }
        });

        this.swiper.on('slideChange', () => {
            let index = this.swiper.realIndex - 1;
            if(index < 0) {
                index = 0;
            }
            this.swiperDays.slideTo(index);
        });

        this.$days.forEach(($day,index) => {
            if($day.classList.contains('is-current')) {
                this.goto(index);
            }
        });
    }

    goto(index) {
        this.swiper.slideTo(index);
        // this.swiperDays.slideTo(index);
    }

    destroy() {
        if(this.swiper !== undefined) {
            this.swiper.destroy()
        }
    }
}